import type { FaireProductEntity } from "../../entity_types/product";

export const p_jmsk4bzvwh: FaireProductEntity = {
  token: "p_jmsk4bzvwh",
  type: "product",
  name: "Tropical Real Fruit Snacks - Passion, Guava, Pineapple 20ct - 400g",
  brandName: "Nakihalani Farm",
  imageUrl:
    "https://cdn.faire.com/fastly/0cbdca06bc875f9d92beb47a24fadf7522390d812c9b69e1a227d5d1330fb593.png",
  priceDollars: 18,
  description: "",
  categoryTokens: ["cat_accessories"],
  tags: [],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T13:23:30Z",
    importedBy: "retailerThemesSeed-migration",
  },
  freeShipping: true,
  brandAvatarUrl:
    "https://cdn.faire.com/fastly/5021a26ce084aaeb2fdc01898db7ab8d6cdc8f52b88a340ad9c2ebba4b153d03.jpeg",
  weight: 0.5,
  dimensions: {
    width: 4,
    height: 4,
    depth: 2,
  },
  inStock: true,
};
